import { MAKER_CHECKER_EVENT_TYPES } from 'utils/constants/commonValues';

import {
    IntegrationView,
    KYCView,
    MerchantView,
    NotificationView,
    PayModeView,
    PGConfigurationView,
    RoutingView,
    SettlementView,
    SurchargeView,
    OnBoardingView,
    MakerDetailsView,
    CheckerApprovalForm,
    TerminalView,
    AmlPepScreeningView
} from 'components/MakerCheckerView';

import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import './checker.scss';

const getComponent = ({ data, auth }) => {
    const requestData = JSON.parse(data.request);

    switch (data.eventType) {
        case MAKER_CHECKER_EVENT_TYPES.ONBOARDING: {
            return <OnBoardingView data={requestData} auth={auth} />;
        }
        case MAKER_CHECKER_EVENT_TYPES.MERCHANT: {
            return <MerchantView data={requestData} auth={auth} />;
        }
        case MAKER_CHECKER_EVENT_TYPES.INTEGRATION: {
            const {
                merchantConfig: { integrationData },
            } = requestData;
            return <IntegrationView data={integrationData} auth={auth} />;
        }
        case MAKER_CHECKER_EVENT_TYPES.PAYMENTMODE: {
            const {
                merchantConfig: { paymentModeData },
            } = requestData;
            return <PayModeView data={paymentModeData} auth={auth} />;
        }

        case MAKER_CHECKER_EVENT_TYPES.SETTLEMENT: {
            return <SettlementView data={requestData} auth={auth} />;
        }

        case MAKER_CHECKER_EVENT_TYPES.PRICING: {
            return <SurchargeView data={requestData} auth={auth} />;
        }

        case MAKER_CHECKER_EVENT_TYPES.KYC: {
            const { merchantConfig: kycSectionData } = requestData;
            const { kycData } = kycSectionData;
            return <KYCView data={kycData} auth={auth} />;
        }

        case MAKER_CHECKER_EVENT_TYPES.PG_CONFIG: {
            return <PGConfigurationView data={requestData} auth={auth} />;
        }

        case MAKER_CHECKER_EVENT_TYPES.ROUTING: {
            return <RoutingView data={requestData} auth={auth} />;
        }

        case MAKER_CHECKER_EVENT_TYPES.NOTIFICATION: {
            const {
                merchantConfig: { notificationData },
            } = requestData;

            return <NotificationView data={notificationData} auth={auth} />;
        }
        case MAKER_CHECKER_EVENT_TYPES.TERMINAL: {
            return <TerminalView data={requestData} auth={auth}  count={true}/>;
        }
        case MAKER_CHECKER_EVENT_TYPES.TERMINAL_UPDATE: {
            return <TerminalView data={requestData} auth={auth} count={false} />;
        }
        case MAKER_CHECKER_EVENT_TYPES.AML_PEP_SCREENING: {
            return <AmlPepScreeningView data={requestData} auth={auth} />
        }
        default:
            return <></>;
    }
};

const CheckerView = props => {
    const { data, auth, closePopup, showLoader, hideLoader } = props;

    return (
        <>
            <MakerDetailsView data={data} />
            {getComponent({ data, auth })}
            {data.status === "INITIATED" ? <CheckerApprovalForm
                requestDetails={data}
                auth={auth}
                closePopup={closePopup}
                showLoader={showLoader}
                hideLoader={hideLoader}
                isBDOnboarding={
                    data.eventType === MAKER_CHECKER_EVENT_TYPES.ONBOARDING
                }
            /> : <></>}
        </>
    );
};

CheckerView.propTypes = {
    data: PropTypes.object,
    auth: PropTypes.object,
    closePopup: PropTypes.func,
    handleOpenActionPopup: PropTypes.func,
    showLoader: PropTypes.func,
    hideLoader: PropTypes.func,
};

getComponent.propTypes = {
    data: PropTypes.object,
    auth: PropTypes.object,
};

const mapStateToProps = ({ auth }) => ({
    auth,
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators({}, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(CheckerView);
